import { occupationSchema } from '../occupationOptions';
import { rentAddressScehama } from './rentAddressSchema';

export const addressOccupationSchema = rentAddressScehama.omit(['rent', 'dueDay']).shape({
  occupation: occupationSchema,
});
